import isArray from 'isarray';
import { SHARED_PASSAGE } from 'chameleon/packages/blue-book-player/constants/sharedPassage';

const findSharedPassages = (features) =>
  features
    .filter((item) => item.type === SHARED_PASSAGE)
    .map((feature) => feature.feature_id);

const isSharedPassageWithQuestion = (
  items,
  isMargin,
  reference,
  currentItemSharedPassages,
) => {
  if (isMargin) return false;

  const itemSharedPassages =
    reference && findSharedPassages(items[reference]?.features);

  return (
    currentItemSharedPassages &&
    itemSharedPassages &&
    currentItemSharedPassages.some((passageId) =>
      itemSharedPassages.includes(passageId),
    )
  );
};

const isSharedPassageWithNextQuestion = (
  items,
  itemReferences,
  index,
  currentItemSharedPassages,
) => {
  const itemsLength = itemReferences.length;
  const isLast = itemsLength - 1 === index;
  const nextReference = itemReferences[index + 1];

  return isSharedPassageWithQuestion(
    items,
    isLast,
    nextReference,
    currentItemSharedPassages,
  );
};

const isSharedPassageWithPreviousQuestion = (
  items,
  itemReferences,
  index,
  currentItemSharedPassages,
) => {
  const previousReference = itemReferences[index - 1];
  const isFirst = index === 0;

  return isSharedPassageWithQuestion(
    items,
    isFirst,
    previousReference,
    currentItemSharedPassages,
  );
};

export const createSharedFeaturesTree = (items) => {
  if (!items) return [];
  const itemReferences = Object.keys(items);
  return itemReferences.reduce((acc, reference, index) => {
    const nodes = acc;
    const prevNode = nodes[nodes.length - 1];
    const currentItemSharedPassages = findSharedPassages(
      items[reference].features,
    );
    if (
      !isSharedPassageWithNextQuestion(
        items,
        itemReferences,
        index,
        currentItemSharedPassages,
      ) &&
      !isSharedPassageWithPreviousQuestion(
        items,
        itemReferences,
        index,
        currentItemSharedPassages,
      )
    ) {
      nodes.push(reference);

      // when previous item is end of set and current is start
    } else if (
      prevNode &&
      isArray(prevNode) &&
      !isSharedPassageWithPreviousQuestion(
        items,
        itemReferences,
        index,
        currentItemSharedPassages,
      )
    ) {
      nodes[nodes.length] = [reference];

      // otherwise keep adding nodes to set
    } else if (prevNode && isArray(prevNode)) {
      prevNode.push(reference);
    } else {
      nodes[nodes.length] = [reference];
    }

    return acc;
  }, []);
};

export const computeSharedPassageInfos = (references, sharedPassageTree) => {
  const sharedPassageInfo = [];
  sharedPassageTree.forEach((node) => {
    if (isArray(node)) {
      sharedPassageInfo.push({
        questionIndexStart: references.indexOf(node[0]),
        questionIndexEnd: references.indexOf(node[node.length - 1]),
        questionsReferences: node,
      });
    }
  });
  return sharedPassageInfo;
};
